/* Goodgudi Art Corner \u2014 diamond painting try-on. Reads window.GGAC (set by the section) and window.GGAC_DATA (kit canvases). */
(function(){
"use strict";
function init(){
const $=id=>document.getElementById("ac-"+id);
if(!$("root")||$("root").dataset.ready) return; $("root").dataset.ready="1";
let CFG=window.GGAC||{}; try{const j=$("config");if(j)CFG=JSON.parse(j.textContent);}catch(e){}
const DATA=(window.GGAC_DATA=window.GGAC_DATA||{});
// Lift the paint screen, finale and toast to the top of <body> so the theme's header,
// sticky wrappers or animated section containers can never sit on top of them.
if(!CFG.preview){
  const old=document.getElementById("ac-portal"); if(old) old.remove();
  const portal=document.createElement("div"); portal.id="ac-portal"; portal.className="gg-ac-root";
  ["editor","finale","toastHost"].forEach(id=>{const el=$(id); if(el) portal.appendChild(el);});
  document.body.appendChild(portal);
}
const KITS=(CFG.kits||[]).filter(k=>k&&k.name);
if(!KITS.length) return;
KITS.forEach(k=>{k.live=!!(k.art&&(DATA[k.art]||(CFG.dataUrl||{})[k.art]));});
const reduce=matchMedia("(prefers-reduced-motion: reduce)").matches;
const esc=s=>String(s==null?"":s).replace(/[&<>"]/g,c=>({"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;"}[c]));

// ---------- kit data (loaded on demand) ----------
const loading={};
function ensureData(art){
  if(DATA[art]) return Promise.resolve(DATA[art]);
  if(loading[art]) return loading[art];
  const url=(CFG.dataUrl||{})[art]; if(!url) return Promise.reject(new Error("no data"));
  return loading[art]=new Promise((ok,fail)=>{const s=document.createElement("script");s.src=url;s.async=true;
    s.onload=()=>DATA[art]?ok(DATA[art]):fail(new Error("bad data"));s.onerror=fail;document.head.appendChild(s);});
}

// ---------- gem sprites ----------
let K=null, KITCOL=[], COLORS=[], C=0, R=0, N=0, W=0, H=0, PAL=null, fill=null, cells=null, cctx=null, lines=null, sheet=null;
const P=8, ST={}, SP=16;
function mix(hex,w,to){const n=parseInt(hex.slice(1),16),r=n>>16&255,g=n>>8&255,b=n&255,t=to??255;return `rgb(${Math.round(r+(t-r)*w)},${Math.round(g+(t-g)*w)},${Math.round(b+(t-b)*w)})`;}
function rgbHex(s){const m=s.match(/\d+/g).map(Number);return "#"+m.map(v=>v.toString(16).padStart(2,"0")).join("");}
function gem(ctx,x,y,s,hex,blank){
  const b=s*.24;
  ctx.fillStyle=hex;ctx.fillRect(x,y,s,s);
  const n=parseInt(hex.slice(1),16),lum=((n>>16&255)*.3+(n>>8&255)*.59+(n&255)*.11), k=blank?.5:(lum<70?.35:1);
  ctx.fillStyle=mix(hex,.45*k);ctx.beginPath();ctx.moveTo(x,y);ctx.lineTo(x+s,y);ctx.lineTo(x+s-b,y+b);ctx.lineTo(x+b,y+b);ctx.fill();
  ctx.fillStyle=mix(hex,.22*k);ctx.beginPath();ctx.moveTo(x,y);ctx.lineTo(x+b,y+b);ctx.lineTo(x+b,y+s-b);ctx.lineTo(x,y+s);ctx.fill();
  ctx.fillStyle=mix(hex,(blank?.06:.36),0);ctx.beginPath();ctx.moveTo(x,y+s);ctx.lineTo(x+b,y+s-b);ctx.lineTo(x+s-b,y+s-b);ctx.lineTo(x+s,y+s);ctx.fill();
  ctx.fillStyle=mix(hex,(blank?.04:.22),0);ctx.beginPath();ctx.moveTo(x+s,y);ctx.lineTo(x+s,y+s);ctx.lineTo(x+s-b,y+s-b);ctx.lineTo(x+s-b,y+b);ctx.fill();
  ctx.fillStyle=mix(hex,.12*k);ctx.fillRect(x+b,y+b,s-2*b,s-2*b);
  if(!blank){ctx.fillStyle=lum<70?"rgba(255,255,255,.45)":"rgba(255,255,255,.8)";ctx.fillRect(x+b*.9,y+b*.9,s*.17,s*.17);}
}
function buildSheet(){
  sheet=document.createElement("canvas"); sheet.width=SP*3; sheet.height=SP*(COLORS.length+1);
  const sc=sheet.getContext("2d");
  COLORS.forEach((hex,ci)=>{for(let v=0;v<3;v++){const t=v===0?hex:rgbHex(v===1?mix(hex,.12):mix(hex,.12,0)); gem(sc,v*SP+.5,ci*SP+.5,SP-1,t,false);}});
  for(let v=0;v<3;v++) gem(sc,v*SP+.5,COLORS.length*SP+.5,SP-1,["#f1ede6","#ece8e1","#f4f1eb"][v],true);
}
const tone=i=>{let h=((i%C)*374761393+((i/C)|0)*668265263)>>>0;h=Math.imul(h^(h>>>13),1274126177)>>>0;return ((h^(h>>>16))>>>0)%3;};

// ---------- canvas state ----------
function drawCell(i,scale){
  const x=(i%C)*P,y=((i/C)|0)*P;
  cctx.fillStyle="#fdfbf7"; cctx.fillRect(x,y,P,P);
  const ci=fill[i], v=tone(i), blank=COLORS.length, row=ci>=0?ci:blank;
  if(ci<0||scale>=1){cctx.drawImage(sheet,v*SP,row*SP,SP,SP,x,y,P,P);return;}
  cctx.drawImage(sheet,v*SP,blank*SP,SP,SP,x,y,P,P);
  if(scale>0){const s=P*scale;cctx.drawImage(sheet,v*SP,row*SP,SP,SP,x+(P-s)/2,y+(P-s)/2,s,s);}
}
const paint=$("paint"), pctx=paint.getContext("2d");
let previewCanvas=null;
function compose(ctx){if(!cells)return;ctx.drawImage(cells,0,0);if(lines&&lines.complete&&lines.naturalWidth){ctx.globalAlpha=.92;ctx.drawImage(lines,0,0,W,H);ctx.globalAlpha=1;}}
function render(){compose(pctx); if(previewCanvas) compose(previewCanvas.getContext("2d"));}
let anim=[], raf=0;
function tick(now){
  raf=0; const left=[];
  for(const a of anim){const p=(now-a.t)/320; if(p<0){left.push(a);continue;}
    if(p>=1){drawCell(a.i,1);} else {const q=p-1; drawCell(a.i,1+2.4*q*q*q+1.4*q*q); left.push(a);} }
  anim=left; render(); if(anim.length) raf=requestAnimationFrame(tick);
}
function kick(){ if(!raf) raf=requestAnimationFrame(tick); }

// ---------- painting: tap a bag, its diamonds land on the canvas ----------
const rail=$("rail"), statusEl=$("status"), wrap=$("canvasWrap"), pen=$("pen"), penGem=$("penGem"), flyLayer=$("flyLayer"), editor=$("editor"), finale=$("finale");
let busy=false, firstDone=false, phase="idle", stack=[], timers=[], byColour=[];
const at=(ms,fn)=>timers.push(setTimeout(fn,ms));
function placedPct(){let d=0;for(let i=0;i<N;i++)if(fill[i]>=0)d++;return Math.round(d/N*100);}
function setPhase(p){phase=p;renderSteps();}
function renderSteps(){
  const done=KITCOL.length&&stack.length===KITCOL.length;
  const now=done?3:phase==="pour"?0:phase==="pick"?1:(phase==="press"||phase==="fly")?2:(firstDone?2:0);
  $("steps").innerHTML=["Pour","Pick","Press","Frame"].map((l,i)=>`<span class="ac-step${i===now?" ac-now":((i<now||done)?" ac-ok":"")}"><i>${i+1}</i><em>${l}</em></span>`).join("");
}
function status(msg,trayCi){
  const tray=trayCi!=null?`<span class="ac-tray">${Array.from({length:18},(_,j)=>`<i style="background:${COLORS[trayCi]};animation-delay:${j*.03}s"></i>`).join("")}</span>`:"";
  statusEl.innerHTML=tray+msg;
}
function idleStatus(){
  const left=KITCOL.length-stack.length;
  if(!stack.length&&!firstDone) status(`<span class="ac-colorName">Tap any diamond bag to start.</span> The canvas is already sticky.`);
  else if(!stack.length) status(`<span class="ac-colorName">Canvas cleared.</span> Tap any bag to place it again.`);
  else if(left===0) status(`<span class="ac-colorName" style="color:var(--red);font-size:26px">ta-da!</span> &nbsp;<span class="ac-colorName">Framed. Fabulous. Totally made by you.</span>`);
  else status(`<span class="ac-colorName">${left===1?"One bag to go!":`Lovely. ${left} bags to go.`}</span> &nbsp;<b>${placedPct()}%</b> sparkled`);
}
function refreshUI(){
  [...rail.querySelectorAll(".ac-bagBtn")].forEach((b,ci)=>{const used=stack.includes(ci);b.classList.toggle("ac-used",used);b.disabled=used||busy;
    b.classList.toggle("ac-hint",!firstDone&&!busy&&ci===0);b.setAttribute("aria-label",`Bag ${KITCOL[ci].code}, ${KITCOL[ci].name}${used?", placed":""}`);});
  $("clearBtn").disabled=busy||!stack.length;
  $("restartBtn").disabled=busy||(!stack.length&&!firstDone);
  renderSteps();
}
function cellXY(i){const rc=paint.getBoundingClientRect(),wr=wrap.getBoundingClientRect();
  return {x:rc.left-wr.left+((i%C)+.5)/C*rc.width, y:rc.top-wr.top+(((i/C)|0)+.5)/R*rc.height};}
function movePen(x,y,show,carry,ci){pen.style.left=(x-4)+"px";pen.style.top=(y-50)+"px";pen.style.opacity=show?1:0;penGem.setAttribute("opacity",carry?1:0);if(ci!=null)penGem.setAttribute("fill",COLORS[ci]);}
function tapBag(ci,btn){
  if(busy||stack.includes(ci)) return;
  busy=true; refreshUI();
  if(!firstDone&&!reduce) demo(ci,btn); else pour(ci,btn);
}
// first bag only: pour into the tray, pick one diamond, press it on its square (x3)
function demo(ci,btn){
  setPhase("pour"); status(`<span class="ac-colorName">Pour bag ${esc(KITCOL[ci].code)} into the tray\u2026</span>`,ci);
  const list=byColour[ci], picks=[list[(list.length*.3)|0],list[(list.length*.55)|0],list[(list.length*.8)|0]];
  const wr=wrap.getBoundingClientRect(), tr=statusEl.getBoundingClientRect(), tray={x:tr.left-wr.left+50,y:tr.top-wr.top+10};
  picks.forEach((cell,j)=>{const b=900+j*1100;
    at(b,()=>{setPhase("pick");status(`<span class="ac-colorName">\u2026the pen picks up one diamond at a time\u2026</span>`,ci);movePen(tray.x,tray.y,true,true,ci);});
    at(b+460,()=>{setPhase("press");status(`<span class="ac-colorName">\u2026and presses it onto its matching symbol.</span>`,ci);const p=cellXY(cell);movePen(p.x,p.y,true,true,ci);});
    at(b+880,()=>{fill[cell]=ci;anim.push({i:cell,t:performance.now()});kick();penGem.setAttribute("opacity",0);});
  });
  at(900+3*1100+150,()=>{movePen(0,0,false,false);firstDone=true;pour(ci,btn,true);});
}
function pour(ci,btn,fromTray){
  setPhase("fly"); status(`<span class="ac-colorName">${fromTray?"Now the rest of them. Sparkle!":"Click, click, click\u2026"}</span>`,fromTray?ci:null);
  const er=editor.getBoundingClientRect(), br=btn.querySelector(".ac-sw").getBoundingClientRect(), rc=paint.getBoundingClientRect(), lr=flyLayer.getBoundingClientRect();
  const ox=br.left-lr.left+br.width/2, oy=br.top-lr.top+br.height/2, list=byColour[ci];
  if(!reduce){let h="";for(let j=0;j<28;j++){const i=list[(j*list.length/28)|0],tx=rc.left-lr.left+((i%C)+.5)/C*rc.width,ty=rc.top-lr.top+(((i/C)|0)+.5)/R*rc.height;
    h+=`<span class="ac-fly" style="left:${ox-4}px;top:${oy-4}px;--dx:${Math.round(tx-ox)}px;--dy:${Math.round(ty-oy)}px;animation-delay:${(j*.022).toFixed(3)}s;background:${COLORS[ci]}"></span>`;}
    flyLayer.innerHTML=h;}
  at(reduce?0:620,()=>{const now=performance.now();
    for(const i of list){if(fill[i]===ci)continue;fill[i]=ci;
      if(reduce)drawCell(i,1);else{const cx=i%C,cy=(i/C)|0;anim.push({i,t:now+(C-1-cx)*7+cy*1.6});}}
    if(reduce)render();else kick();});
  at(reduce?50:1650,()=>{flyLayer.innerHTML="";stack.push(ci);busy=false;setPhase("idle");refreshUI();idleStatus();
    if(stack.length===KITCOL.length) finish();});
}
function finish(){
  wrap.classList.add("ac-framed");
  const sh=$("shine");sh.hidden=true;void sh.offsetWidth;sh.hidden=false;
  renderSteps(); at(2600,showFinale);
}
function unframe(){wrap.classList.remove("ac-framed");$("shine").hidden=true;}
function wipe(){timers.forEach(clearTimeout);timers=[];flyLayer.innerHTML="";movePen(0,0,false,false);anim=[];busy=false;
  stack=[];for(let i=0;i<N;i++){fill[i]=-1;drawCell(i,1);}unframe();render();}
// Clear: every diamond comes off the canvas in one go
$("clearBtn").onclick=()=>{if(!stack.length) return; wipe(); setPhase("idle"); refreshUI(); idleStatus();};
// Start over: also replays the pour / pick / press demo on the next bag
$("restartBtn").onclick=()=>{wipe(); firstDone=false; setPhase("idle"); refreshUI(); idleStatus();};
function buildRail(){
  rail.innerHTML="";
  KITCOL.forEach((k,ci)=>{const b=document.createElement("button");b.type="button";b.className="ac-bagBtn";
    b.innerHTML=`<span class="ac-sw" style="background:${k.hex}"><span>${esc(k.code)}</span></span><span class="ac-nm">${esc(k.code)} \u00b7 ${esc(k.name)}</span>`;
    b.onclick=()=>tapBag(ci,b);rail.appendChild(b);});
  refreshUI(); if(!busy) idleStatus();
}
function loadKit(kit){
  if(K&&ST[K.art]){const o=ST[K.art];o.stack=stack;o.firstDone=firstDone;}
  const d=DATA[kit.art]; K=kit;
  if(!ST[kit.art]){
    const n=d.cols*d.rows, pal=new Uint8Array(n);
    for(let i=0;i<n;i++) pal[i]=d.pal.charCodeAt(i)-48;
    const cv=document.createElement("canvas"); cv.width=d.cols*P; cv.height=d.rows*P;
    const img=new Image(); img.onload=render; img.src="data:image/png;base64,"+d.lines;
    ST[kit.art]={pal,fill:new Int8Array(n).fill(-1),cells:cv,lines:img,stack:[],firstDone:false,fresh:true};
  }
  const s=ST[kit.art];
  KITCOL=d.bags.map(b=>({code:b[0],name:b[1],hex:b[2]})); COLORS=KITCOL.map(k=>k.hex);
  C=d.cols; R=d.rows; N=C*R; W=C*P; H=R*P; PAL=s.pal; fill=s.fill; cells=s.cells; cctx=cells.getContext("2d"); lines=s.lines;
  stack=s.stack; firstDone=s.firstDone; anim=[];
  byColour=KITCOL.map((_,ci)=>{const a=[];for(let i=0;i<N;i++)if(PAL[i]===ci)a.push(i);return a;});
  buildSheet();
  if(s.fresh){for(let i=0;i<N;i++)drawCell(i,1);s.fresh=false;}
  paint.width=W; paint.height=H;
  $("eTitle").textContent=kit.name;
  $("finalImg").alt=`Your finished ${kit.name} diamond painting`;
}
const easel=$("easel");
function fit(){const w=easel.clientWidth,h=easel.clientHeight-130;if(w<=0||h<=0||!H)return;
  const ar=W/H, s=Math.max(60,Math.min((w-(w<500?20:36))/ar,h));
  paint.style.width=(s*ar)+"px";paint.style.height=s+"px";}
if(window.ResizeObserver) new ResizeObserver(fit).observe(easel); else addEventListener("resize",fit);

// ---------- editor open / close ----------
let lastFocus=null, prevOverflow="";
function lockScroll(on){const el=document.documentElement;if(CFG.preview)return;if(on){prevOverflow=el.style.overflow;el.style.overflow="hidden";}else el.style.overflow=prevOverflow;}
function openEditor(){
  const kit=TRY[kitSel]; if(!kit||!DATA[kit.art]) return;
  lastFocus=document.activeElement; loadKit(kit); editor.hidden=false; lockScroll(true); buildRail(); fit(); render(); $("closeBtn").focus();
}
function closeEditor(){
  timers.forEach(clearTimeout);timers=[];
  if(busy){busy=false;flyLayer.innerHTML="";movePen(0,0,false,false);for(const a of anim)drawCell(a.i,1);anim=[];setPhase("idle");}
  editor.hidden=true; lockScroll(false); render(); lastFocus&&lastFocus.focus&&lastFocus.focus();
}
$("closeBtn").onclick=closeEditor;
function showFinale(){
  const d=placedPct(); render();
  $("finalImg").src=paint.toDataURL("image/jpeg",.9);
  $("fText").textContent=d>=100
    ? "Every diamond placed. The real kit comes with a printed sticky canvas, all the diamonds and a white frame, ready to hang."
    : `You sparkled ${d}% of the canvas. Finish the real one at your desk: sticky canvas, diamonds, pen and a white frame included.`;
  $("fAdd").textContent=added[K.key]?`${K.name} is in your bag`:`Add ${K.name} kit \u00b7 ${K.price}`;
  finale.hidden=false; $("fAdd").focus();
}
$("doneBtn").onclick=showFinale;
$("fKeep").onclick=()=>{finale.hidden=true;};
$("fAdd").onclick=()=>{const k=K;finale.hidden=true;closeEditor();addToBag(k);};
document.addEventListener("keydown",e=>{if(e.key!=="Escape"||!editor.isConnected)return;if(!finale.hidden)finale.hidden=true;else if(!editor.hidden)closeEditor();});

// ---------- cart ----------
const added={};
function toast(msg){
  const host=$("toastHost"); host.innerHTML=`<div class="ac-toast" role="status">${esc(msg)}${CFG.preview?"":`<a href="${esc(CFG.cartUrl||"/cart")}">View bag</a>`}</div>`;
  clearTimeout(toast.t); toast.t=setTimeout(()=>{host.innerHTML="";},3200);
}
function refreshThemeCart(cart){
  // Boost (Clean Canvas) listens for these; generic fallbacks update any visible count badge
  const n=cart&&cart.item_count;
  document.dispatchEvent(new CustomEvent("on:cart:add",{bubbles:true,detail:{cart}}));
  document.dispatchEvent(new CustomEvent("dispatch:cart-drawer:refresh",{bubbles:true}));
  document.dispatchEvent(new CustomEvent("cart:refresh",{bubbles:true,detail:{cart}}));
  if(n!=null) document.querySelectorAll("[data-cart-count],.cart-count,.js-cart-count,.cart-link__count,#cart-icon-bubble .cart-count-bubble span").forEach(el=>{el.textContent=n;el.hidden=false;});
}
function addToBag(kit){
  if(added[kit.key]) return;
  if(CFG.preview||!kit.variantId){added[kit.key]=true;renderAll();toast(`${kit.name} kit added to bag`);return;}
  if(kit.available===false){toast(`${kit.name} is sold out right now`);return;}
  fetch((window.Shopify&&Shopify.routes&&Shopify.routes.root||"/")+"cart/add.js",{method:"POST",headers:{"Content-Type":"application/json",Accept:"application/json"},
    body:JSON.stringify({items:[{id:kit.variantId,quantity:1}]})})
    .then(r=>{if(!r.ok)throw r;return fetch((window.Shopify&&Shopify.routes&&Shopify.routes.root||"/")+"cart.js");})
    .then(r=>r.json())
    .then(cart=>{added[kit.key]=true;renderAll();
      if(CFG.afterAdd==="cart"){location.href=CFG.cartUrl||"/cart";return;}
      refreshThemeCart(cart);toast(`${kit.name} kit added to bag`);})
    .catch(()=>toast("Couldn't add that, please try again"));
}

// ---------- landing: kit tabs (live canvases only), hero card, pill, shop grid ----------
// Kits without a live canvas (e.g. Chibi) appear only in the product grid.
let TRY=KITS.filter(k=>k.live), kitSel=0;
const heroTpl=CFG.heroTpl||"Sparkle your own [kit] diamond painting";
function noTry(){["heroTitle","startBtn"].forEach(id=>$(id).hidden=true);$("tryCard").closest(".ac-heroCard").hidden=true;$("tryTitle").closest(".ac-try").hidden=true;}
function dropKit(k){TRY=TRY.filter(x=>x!==k);kitSel=0;if(!TRY.length){noTry();return;}renderTabs();renderTry();}
function renderTabs(){
  const t=$("kitTabs"); t.innerHTML="";
  TRY.forEach((k,j)=>{const b=document.createElement("button"); b.type="button"; b.className="ac-kitTab"; b.setAttribute("aria-pressed",String(j===kitSel));
    b.innerHTML=`${k.thumb?`<img src="${esc(k.thumb)}" alt="" loading="lazy">`:""}<span><b>${esc(k.name)}</b><small>Try it live</small></span>`;
    b.onclick=()=>{kitSel=j;renderTabs();renderTry();$("tryCard").scrollIntoView({behavior:reduce?"auto":"smooth",block:"center"});}; t.appendChild(b);});
  t.style.gridTemplateColumns=`repeat(${Math.min(TRY.length,4)},minmax(0,1fr))`;
  t.classList.toggle("ac-kits-odd",TRY.length%2===1);
  $("tryNote").textContent=TRY.length>1?`${TRY.length} kits to try`:"";
}
function renderPill(){
  if(!TRY.length) return;
  const k=TRY[kitSel], pill=$("heroPill");
  $("pillLbl").textContent=added[k.key]?`${k.name} added to bag`:`Get the ${k.name}`;
  $("pillPrice").textContent=added[k.key]?"\u2713 Added":k.price;
  pill.classList.toggle("ac-added",!!added[k.key]); pill.onclick=()=>addToBag(k);
}
function renderTry(){
  if(!TRY.length) return;
  const k=TRY[kitSel], card=$("tryCard");
  $("heroTitle").textContent=heroTpl.replace("[kit]",k.name);
  renderPill();
  if(!DATA[k.art]){
    previewCanvas=null;
    card.innerHTML=`<div class="ac-loading">Laying out the diamonds\u2026</div>`;
    ensureData(k.art).then(()=>{if(TRY[kitSel]===k)renderTry();}).catch(()=>dropKit(k));
    return;
  }
  loadKit(k);
  card.innerHTML=`<button type="button" class="ac-canvasBtn${W>H?" ac-wide":""}" id="ac-canvasBtn" aria-label="Open the ${esc(k.name)} canvas and start sparkling"><canvas id="ac-preview" width="${W}" height="${H}" style="aspect-ratio:${W}/${H}"></canvas><span class="ac-tapHint"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"><path d="M9 11V5a2 2 0 014 0v6"/><path d="M13 9a2 2 0 014 0v3a7 7 0 01-7 7h-.5A6.5 6.5 0 014 13l-1-3a1.6 1.6 0 013-1l1 2"/></svg>Tap the canvas to start sparkling</span></button>`;
  previewCanvas=$("preview"); compose(previewCanvas.getContext("2d"));
  $("canvasBtn").onclick=openEditor;
}
$("startBtn").onclick=()=>{
  if(!TRY.length) return;
  const k=TRY[kitSel]; ensureData(k.art).then(()=>{if(!previewCanvas)renderTry();openEditor();}).catch(()=>dropKit(k));
};
function renderShop(){
  const g=$("shopGrid"); g.innerHTML="";
  KITS.forEach(k=>{const d=document.createElement("div"); d.className="ac-prod"; const on=!!added[k.key], sold=k.available===false;
    d.innerHTML=`${k.photo?`<img src="${esc(k.photo)}" alt="Diamond painting kit ${esc(k.name)}" loading="lazy">`:""}<div class="ac-n">${esc(k.name)}</div><div class="ac-m">Diamond Painting Kit \u00b7 frame included</div><div class="ac-row"><span class="ac-price">${esc(k.price)}</span><button type="button" class="ac-mini${on?" ac-on":""}"${sold&&!on?" disabled":""}>${on?"Added":sold?"Sold out":"Add to bag"}</button></div>`;
    d.querySelector("button").onclick=()=>addToBag(k); g.appendChild(d);});
}
function renderAll(){renderPill();renderTry();renderShop();}
if(TRY.length){renderTabs(); renderTry();} else noTry();
renderShop();
}
if(document.readyState==="loading") document.addEventListener("DOMContentLoaded",init); else init();
document.addEventListener("shopify:section:load",init);
})();
